import * as moment from 'moment';
import { momentFormat as defaultFormat } from '../common';

export const filterId = 'wtDate';

export interface IwtDateFilter {
    (input: string, momentFormat?: string, nullFallback?: string): string;
}

export const factory: () => IwtDateFilter = () => {
    return (input: string, momentFormat?: string, nullFallback?:string) => {
        if (!momentFormat) {
            momentFormat = defaultFormat;
        }
        if (!input && nullFallback) {
            return nullFallback;
        }
        return moment(input).format(momentFormat);
    };
};